import { required, email } from '@client/utils/Validators';

import FormControl from '@client/components/FormControl';
import TextField from '@client/components/TextField';
import Box from '@client/components/Box';
import Button from '@client/components/Button';

interface Props {
  handleSubmit: Function;
}

const ForgotPasswordForm: React.FC<Props> = ({ handleSubmit }) => {
  return (
    <>
      <Box as="form" onSubmit={handleSubmit}>
        <FormControl
          as={TextField}
          type="text"
          name="email"
          label="Email"
          placeholder="Input Email"
          validate={[required, email]}
        />

        <Box className="btn-area mt-4">
          <Button type="submit" className="btn-primer w-100">
            Send
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ForgotPasswordForm;
